/** @jsx jsx */
import { jsx } from '@theme-ui/core';

import { Translation, translations } from 'src/shared/translation';
import { UberallIcon } from 'src/shared/components/icons';

const transl = translations.nearmecheck.shared.watermark;

export function Watermark(props: JSX.IntrinsicElements['div']) {
    return (
        <div {...props} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Translation
                code={transl.powered_by}
                sx={{ display: 'block', fontSize: 3, paddingRight: 1 }}
            />

            <UberallIcon />
        </div>
    );
}
